import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const MenuHamburgerIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="MenuHamburgerIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/menu-hamburger">
            <path d="M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </g>
    </SvgIcon>
)
